import { Account } from "@/services/cloudchipr.api";
import {
  HighchartsChartDataSeriesOption,
  HighchartsChartDataType,
} from "@/storybook/c8r-highcharts/common/utils/types/common";

export const accountsHighchartsDataGenerator = (
  accounts: Account[] | null,
): HighchartsChartDataType => {
  if (!accounts?.length) {
    return {
      categories: [],
      series: [
        { name: "Tracked Total", data: [], color: "#4CAF50" },
        { name: "Underutilized", data: [], color: "#F44336" },
      ],
    };
  }

  const namedAccounts = accounts.map((account) => {
    const name =
      account.provider_account_name ||
      account.provider_account_id ||
      account.id;

    return {
      name,
      trackedTotal: account.total_costs || 0,
      underutilized: account.ems || 0,
    };
  });

  let displayAccounts = namedAccounts;

  if (namedAccounts.length > 15) {
    const firstPart = namedAccounts.slice(0, 14);
    const othersGroup = namedAccounts.slice(14);

    const others = othersGroup.reduce(
      (acc, curr) => ({
        name: "Others",
        trackedTotal: acc.trackedTotal + curr.trackedTotal,
        underutilized: acc.underutilized + curr.underutilized,
      }),
      { name: "Others", trackedTotal: 0, underutilized: 0 },
    );

    displayAccounts = [...firstPart, others];
  }

  const categories = displayAccounts.map((acc) => acc.name);

  const trackedTotalSeries: HighchartsChartDataSeriesOption = {
    name: "Tracked Total",
    color: "#4CAF50",
    data: displayAccounts.map((acc) => ({
      y: acc.trackedTotal,
    })),
  };

  const underutilizedSeries: HighchartsChartDataSeriesOption = {
    name: "Underutilized",
    color: "#F44336",
    data: displayAccounts.map((acc) => ({
      y: acc.underutilized,
    })),
  };

  return {
    categories,
    series: [trackedTotalSeries, underutilizedSeries],
  };
};
